import { AxiosInstance } from "axios"

import type { MonetaryAmount } from "../../../../../currency/currencyTypes"

export enum UserPaymentAccountQuery {
    USER_PAYMENT_ACCOUNT = "user-payment-account",
}

export type UserPaymentAccountResponse = Readonly<{
    userAccountBalance: MonetaryAmount
}>

export async function fetchUserPaymentAccount(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UserPaymentAccountResponse> {
    const { data } = await axios.get<UserPaymentAccountResponse>("/me/payment/account", { signal })
    return data
}
